import Factory2 from './Factory2';
export default Factory2;
